var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "goal-selection" },
    [
      _c("section-title", {
        attrs: { "has-line": "", title: "Metas Académicas Relacionada(s)" }
      }),
      _c(
        "div",
        {
          staticClass:
            "d-flex flex-row justify-content-between align-items-start"
        },
        [
          _c(
            "div",
            { staticClass: "col-12 pr-3 border-right" },
            [
              _c("validation-provider", {
                ref: "goalValidator",
                attrs: { name: "customDropDownGoal" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("CustomMultiSelect", {
                          attrs: {
                            "error-message": errors[0],
                            label: "Seleccionar Meta:",
                            options: _vm.availableGoalOptions
                          },
                          model: {
                            value: _vm.selectedGoals,
                            callback: function($$v) {
                              _vm.selectedGoals = $$v
                            },
                            expression: "selectedGoals"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("div", { staticClass: "row mt-3" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("Error", {
                      attrs: {
                        "is-alert-mode": "",
                        message:
                          "Puede seleccionar una(1) o más metas. Selección múltiple."
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }